import React, { Component } from 'react';
import wx from 'weixin-js-sdk';

var browser = {
    versions: function () {
        var u = navigator.userAgent;
        return {
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 || u.indexOf('Linux') > -1,
        };
    }(),
};

class AuthenticateBindingSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            countdown: 5,
            isSuccess: true,
            message: '恭喜你，完成了身份认证，点击完成返回',
        };
        this.timer = null;
    }

    componentDidMount() {
        document.title = '认证结果';
        const { isSuccess, message } = this.parseRouteParams();
        this.setState({
            isSuccess,
            message: message || (isSuccess ? '恭喜你，完成了身份认证，点击完成返回' : '认证失败'),
        }, () => {
            this.startCountdown();
        });
    }

    parseRouteParams = () => {
        const search = window.location.search.slice(1);
        const params = search.split('&');
        const theRequest = {};
        for (let i = 0; i < params.length; i++) {
            const eqIndex = params[i].indexOf('=');
            if (eqIndex !== -1) {
                theRequest[params[i].substring(0, eqIndex)] = decodeURIComponent(params[i].substring(eqIndex + 1));
            }
        }
        return {
            isSuccess: theRequest.isSuccess !== '0',
            message: theRequest.message,
        };
    }

    onBack = () => {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            wx.miniProgram.getEnv((res) => {
                if (res.miniprogram) {
                    wx.miniProgram.switchTab({
                        url: '/pages/index/index',
                    });
                    return;
                }
            });
            return;
        }

        if (/Alipay/i.test(navigator.userAgent)) {
            window.location.href = 'alipays://platformapi/startapp?appId=2018090661238647&page=pages/index/index';
            return;
        }

        var userAgent = navigator.userAgent;
        const OpenHarmony = /(OpenHarmony).*?/.test(userAgent);
        if (browser.versions.android || OpenHarmony) {
            window.android.onCampusPayExit();
            return;
        }
        if (browser.versions.ios) {
            window.webkit.messageHandlers.onCampusPayExit.postMessage('');
        }
    };

    componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    startCountdown = () => {
        this.timer = setTimeout(() => {
            if (this.state.countdown <= 1) {
                this.onBack();
            } else {
                this.setState(
                    prevState => ({ countdown: prevState.countdown - 1 }),
                    this.startCountdown
                );
            }
        }, 1000);
    };

    handleClick = () => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.onBack();
    };

    render() {
        const { countdown, message, isSuccess } = this.state;
        return (
            <div style={{ textAlign: 'center', marginTop: '8vh' }}>
                <img
                    style={{ width: '120px' }}
                    src={isSuccess ? require('../../assets/wancheng.png') : require('../../assets/icon-close-warn.png')}
                    alt=""
                />
                <div style={{ fontSize: '18px', marginTop: '20px' }}>
                    {isSuccess ? '认证成功' : '认证失败'}
                </div>
                <div style={{ fontSize: '15px', color: '#999', marginTop: '10px' }}>{message}</div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '50px',
                }}>
                    <button
                        onClick={this.handleClick}
                        style={{
                            width: '300px',
                            padding: '8px 0',
                            fontSize: '16px',
                            background: 'linear-gradient(270deg, #5BA1FD 0%, #6FBDFF 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '30px',
                            cursor: 'pointer',
                        }}
                    >
                        完成（{countdown}s）
                    </button>
                </div>
            </div>
        );
    }
}

export default AuthenticateBindingSuccess;
